export default __webpack_public_path__ + "static/media/gpay.fc0375dc.webp";